import { get, post } from 'utils/methods';

export function exportStatisticsGroupsApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_FINANCE}commands/export`, data, headers);
}

export function getStatisticsGroupsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_FINANCE}get-accountancy-groups`, data, headers);
}

export function getExportInvoicesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_FINANCE}exports`, data, headers);
}

export function getStatisticsInvoicesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_FINANCE}get-invoices`, data, headers);
}
